import { InfiniteListBase, useListContext, useTranslate } from "ra-core";
import { Link } from "react-router";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { ClientsTabs } from "../misc/ClientsTabs";
import { InfinitePagination } from "../misc/InfinitePagination";
import type { Company } from "../types";
import { CompanyAvatar } from "./CompanyAvatar";

/** «Клиенты → Компании» on a phone: name, city and phone, a tap opens it. */
export const CompanyListMobile = () => (
  <InfiniteListBase perPage={25} sort={{ field: "name", order: "ASC" }}>
    <MobileHeader showRefresh>
      <ClientsTabs />
    </MobileHeader>
    <MobileContent>
      <CompanyRowsMobile />
    </MobileContent>
  </InfiniteListBase>
);

const CompanyRowsMobile = () => {
  const translate = useTranslate();
  const { data: companies, isPending, error } = useListContext<Company>();
  if (isPending) return null;
  if (error && !companies) {
    return (
      <p className="p-4 text-center text-muted-foreground">
        {translate("ra.notification.http_error")}
      </p>
    );
  }
  if (!companies?.length) {
    return (
      <p className="p-4 text-muted-foreground">
        {translate("resources.companies.empty.title")}
      </p>
    );
  }
  return (
    <>
      <div>
        {companies.map((company) => (
          <Link
            key={company.id}
            to={`/companies/${company.id}/show`}
            className="flex flex-row gap-4 items-center py-2 hover:bg-muted transition-colors"
          >
            <CompanyAvatar record={company} width={40} height={40} />
            <div className="min-w-0">
              <div className="font-medium truncate">{company.name}</div>
              <div className="text-sm text-muted-foreground truncate">
                {[company.city, company.phone_number]
                  .filter(Boolean)
                  .join(" · ")}
              </div>
            </div>
          </Link>
        ))}
      </div>
      <div className="flex justify-center">
        <InfinitePagination />
      </div>
    </>
  );
};
